import HomeScreen from 'features/home/HomeScreen/HomeScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function HomeTab() {
  return (
    <PinwheelContextProvider>
      <HomeScreen />
    </PinwheelContextProvider>
  );
}
